import { NgModule } from '@angular/core';
import { ResidentialPropertyStatisticsComponent } from './component/residential-property-statistics/residential-property-statistics.component';
import { NonResidentialPropertyStatisticsComponent } from './component/non-residential-property-statistics/non-residential-property-statistics.component';

import { ContractDurationComponent } from './component/contract-duration/contract-duration.component';
import { MonthRentComponent } from './component/month-rent/month-rent.component';
import { TotalSurfaceComponent } from './component/total-surface/total-surface.component';
import { VacanciesComponent } from './component/vacancies/vacancies.component';

import { CoreModule } from './../core/core.module';
import { TotalAmountComponent } from './component/total-amount/total-amount.component';
import { InvoiceCountComponent } from './component/invoice-count/invoice-count.component';
import { LeaseAgreementCountComponent } from './component/lease-agreement-count/lease-agreement-count.component';
import { CategoryInvoiceAmountComponent } from './component/category-invoice-amount/category-invoice-amount.component';
import { ArticleInvoiceAmountComponent } from './component/article-invoice-amount/article-invoice-amount.component';
import { InvoicesOverviewComponent } from './component/invoices-overview/invoices-overview.component';
import { SystemOverviewComponent } from './component/overview/system-overview.component';
import { NotificationBoardService } from './service/notification-board.service';
import { NotificationBoardComponent } from './component/notification-board/notification-board.component';
import { CommonModule } from '../common/common.module';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [
    ContractDurationComponent,
    InvoicesOverviewComponent,
    MonthRentComponent,
    ResidentialPropertyStatisticsComponent,
    NonResidentialPropertyStatisticsComponent,
    TotalSurfaceComponent,
    VacanciesComponent,
    TotalAmountComponent,
    InvoiceCountComponent,
    LeaseAgreementCountComponent,
    CategoryInvoiceAmountComponent,
    ArticleInvoiceAmountComponent,
    SystemOverviewComponent,
    NotificationBoardComponent,
  ],
  exports: [InvoicesOverviewComponent, NonResidentialPropertyStatisticsComponent, ResidentialPropertyStatisticsComponent],
  providers: [NotificationBoardService],
})
export class OverviewModule {}
